import { DataGrid, type DataGridProps, type GridValidRowModel } from '@shared/components';

import { type Announcement, columns } from './column';

type BaseAnnouncementListProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridProps<TRowModel>,
  'columns'
>;

export default function BaseAnnouncementList(
  props: Readonly<BaseAnnouncementListProps<Announcement>>,
) {
  return (
    <DataGrid
      disableColumnMenu
      {...props}
      columns={columns}
      rowHeight={72}
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '820px',
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.grey[100],
        },
      })}
    />
  );
}
